/**
 * Route name identifiers for typed navigation and matching. Kept apart from
 * route_configs.ts so importing a name does not pull the route tables and every
 * page component into the type graph.
 */
export enum RouteNames {
   BOARD = 'board',
   BOARD_SETTINGS = 'board-settings',
   BOARD_SETTINGS_FIELDS = 'board-settings-fields',
   NOT_FOUND = 'not-found',

   // Auth area
   AUTH_SIGN_IN = 'auth-sign-in',
   AUTH_SIGN_UP = 'auth-sign-up',
   AUTH_FORGOT_PASSWORD = 'auth-forgot-password',
   AUTH_RESET_PASSWORD = 'auth-reset-password',
   AUTH_VERIFY_EMAIL = 'auth-verify-email',
   AUTH_INVITATION = 'auth-invitation',

   // Settings area
   SETTINGS_PROFILE = 'settings-profile',
   SETTINGS_ACCOUNT_SECURITY = 'settings-account-security',
   SETTINGS_API_KEYS = 'settings-api-keys',
   SETTINGS_INVITATIONS = 'settings-invitations',
   SETTINGS_ORG_GENERAL = 'settings-org-general',
   SETTINGS_ORG_MEMBERS = 'settings-org-members',
   SETTINGS_ORG_API_KEYS = 'settings-org-api-keys',
   SETTINGS_ORG_SECURITY = 'settings-org-security',
   SETTINGS_ORG_BILLING = 'settings-org-billing',
   SETTINGS_TESTING_COMM = 'settings-testing-comm',

   // Admin area (app-level administration, gated to app admins)
   ADMIN_USERS = 'admin-users',
   ADMIN_USER_DETAIL = 'admin-user-detail',

   // Dev area (routes registered only in development builds)
   DEV_DESIGN_SYSTEM = 'dev-design-system',
   DEV_COMPONENTS = 'dev-components',
   DEV_ICONS = 'dev-icons',
   DEV_RAW_STORE = 'dev-raw-store',
   DEV_LIVE_FORM = 'dev-live-form',
   DEV_DESIGN_LANGUAGE = 'dev-design-language',
   DEV_POSTHOG_TESTS = 'dev-posthog-tests',

   // Dev area: design-language pattern pages
   DEV_PAT_SURFACES = 'dev-pat-surfaces',
   DEV_PAT_APP_BAR = 'dev-pat-app-bar',
   DEV_PAT_BOARD_TOOLBAR = 'dev-pat-board-toolbar',
   DEV_PAT_BOARD_SURFACE = 'dev-pat-board-surface',
   DEV_PAT_CARD_FRONT = 'dev-pat-card-front',
   DEV_PAT_CARD_DETAIL = 'dev-pat-card-detail',
   DEV_PAT_CARD_BACK = 'dev-pat-card-back',
   DEV_PAT_COMMENTS = 'dev-pat-comments',
   DEV_PAT_SUB_ITEMS = 'dev-pat-sub-items',
   DEV_PAT_NOTIFICATIONS = 'dev-pat-notifications',
   DEV_PAT_GLOBAL_SEARCH = 'dev-pat-global-search',
   DEV_PAT_BUTTONS = 'dev-pat-buttons',
   DEV_PAT_CHIPS = 'dev-pat-chips',
   DEV_PAT_MENUS = 'dev-pat-menus',
   DEV_PAT_FILTERING = 'dev-pat-filtering',
   DEV_PAT_FILTER_TABLE = 'dev-pat-filter-table',
   DEV_PAT_DENSE_FORM = 'dev-pat-dense-form',
   DEV_PAT_LIVE_EDIT = 'dev-pat-live-edit',
   DEV_PAT_DIALOGS = 'dev-pat-dialogs',
   DEV_PAT_INLINE_EDIT = 'dev-pat-inline-edit',
   DEV_PAT_UNDO = 'dev-pat-undo',
   DEV_PAT_CONFIG_SHELLS = 'dev-pat-config-shells',
   DEV_PAT_PAGE_SKELETON = 'dev-pat-page-skeleton',
   DEV_PAT_PANEL_ANATOMY = 'dev-pat-panel-anatomy',
   DEV_PAT_EMPTY_STATES = 'dev-pat-empty-states',
   DEV_PAT_ERROR_STATES = 'dev-pat-error-states',
   DEV_PAT_DO_DONT = 'dev-pat-do-dont',
}
